// extracted by mini-css-extract-plugin
export default {"text":"CTABlock_text__kD57H"};